import { useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import DatePicker, { registerLocale } from 'react-datepicker'
import { ja } from 'date-fns/locale'
import { dateToMonth, isValidMonthRange, monthToDate, toMonthRangeParams } from './helpers'

registerLocale('ja', ja)

type MonthRangeFormProps = {
  from: string
  to: string
  onSubmit: (params: Record<string, string>) => void
}

export const MonthRangeForm = ({ from: initialFrom, to: initialTo, onSubmit }: MonthRangeFormProps) => {
  const [from, setFrom] = useState(initialFrom)
  const [to, setTo] = useState(initialTo)
  const [invalid, setInvalid] = useState(false)

  const handleSubmit = (event: React.SubmitEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!isValidMonthRange(from, to)) {
      setInvalid(true)
      return
    }
    setInvalid(false)
    onSubmit(toMonthRangeParams(from, to))
  }

  return (
    <Form noValidate onSubmit={handleSubmit} className='my-3'>
      <Row className='g-2 align-items-center'>
        <Col xs='auto'>
          <Form.Label htmlFor='monthlyEngineStatsFrom' className='mb-0'>
            開始月
          </Form.Label>
        </Col>
        <Col xs='auto'>
          <DatePicker
            id='monthlyEngineStatsFrom'
            selected={monthToDate(from)}
            onChange={(date: Date | null) => setFrom(dateToMonth(date))}
            showMonthYearPicker
            locale='ja'
            dateFormat='yyyy年M月'
            isClearable
            showIcon
            toggleCalendarOnIconClick
            className={`form-control${invalid ? ' is-invalid' : ''}`}
          />
        </Col>
        <Col xs='auto'>〜</Col>
        <Col xs='auto'>
          <Form.Label htmlFor='monthlyEngineStatsTo' className='mb-0'>
            終了月
          </Form.Label>
        </Col>
        <Col xs='auto'>
          <DatePicker
            id='monthlyEngineStatsTo'
            selected={monthToDate(to)}
            onChange={(date: Date | null) => setTo(dateToMonth(date))}
            showMonthYearPicker
            locale='ja'
            dateFormat='yyyy年M月'
            isClearable
            showIcon
            toggleCalendarOnIconClick
            className={`form-control${invalid ? ' is-invalid' : ''}`}
          />
        </Col>
        <Col xs='auto'>
          <Button type='submit'>表示</Button>
        </Col>
      </Row>
      {invalid && (
        <Form.Control.Feedback type='invalid' className='d-block'>
          開始月は終了月以前を指定してください
        </Form.Control.Feedback>
      )}
    </Form>
  )
}
